/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

// Interactive Imports
import Loading from "../../../../Components/Interactive/Loading";

// MUI Imports
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import AddIcon from "@mui/icons-material/Add";
import ToolTip from "../../../../Components/Interactive/ToolTip";

// Inner JSX Imports
import CallNotesTable from "./CallNotes/CallNotesTable";

// Component Imports
import EditModal from "../../../../Components/EditModal";

const CustomerCallNotesWidget = ({
  allCustomerData,
  loading,
  setCustomerData,
  setUpdatedData,
}) => {
  // Get userId
  const auth = useSelector((state) => state.auth);

  // UI Functionality State
  const [open, setIsOpen] = useState(true);
  const [toggleDropdown, setToggleDropdown] = useState(true);
  const [modalIsOpen, setModalOpen] = useState(false);

  // Dispoition and note related state
  const [note, setNote] = useState("");
  const [selectedDisposition, setSelectedDisposition] = useState(null);
  const [selectedId, setSelectedOrderId] = useState("");
  const [selectedDispositionDesc, setselectedDispositionDesc] = useState("");
  const [dispData, setDispData] = useState([]);

  const {
    userCallNotesInfo: { callNotes },
    userDetailsInfo: { customerId },
    dispositions: { dispositions },
    userOrders: { orders },
  } = allCustomerData;

  useEffect(() => {
    if(!dispositions || dispositions.length === 0) {
      setDispData(JSON.parse(localStorage.getItem("dispositions")))
    }
  }, [allCustomerData])

  // Open modal and also process dispositions request
  const handleOpen = async (e) => setModalOpen(true);
  const handleClose = (e) => setModalOpen(false);

  // Submit new call note
  const handleSubmitNote = async (e) => {
    const res = await fetch(`/api/customer/${customerId}/call-note/add`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        DispositionId: selectedDisposition || null,
        UserId: auth.userInfo.userData.userId,
        OrderId: selectedId,
        Content: note,
      }),
    });

    const { success } = await res.json();

    if (success) {
      setCustomerData((prevState) => ({
        userDetailsInfo: prevState.userDetailsInfo,
        userOrders: prevState.userOrders,
        userPaymentInfo: prevState.userPaymentInfo,
        userCallNotesInfo: {
          ...prevState.userCallNotesInfo,
          callNotes: [
            {
              displayName: auth.userInfo.userData.displayName,
              orderId: selectedId || null,
              callNoteContent: note,
              dispositionDescription: selectedDispositionDesc,
              noteDate: Date.now(),
            },
            ...prevState.userCallNotesInfo.callNotes,
          ],
        },
        userEmailNotesInfo: prevState.userEmailNotesInfo,
        userMembershipInfo: prevState.userMembershipInfo,
        userTrackingInfo: prevState.userTrackingInfo,
        userProgramsInfo: prevState.userProgramsInfo,
        userLoginHistoryInfo: prevState.userLoginHistoryInfo,
        dispositions: prevState.dispositions,
        userEvents: prevState.userEvents,
        userReportHistory: prevState.userReportHistory,
        userCallLog: prevState.userCallLog,
        userLockouts: prevState.userLockouts,
        userReportDownloads: prevState.userReportDownloads
      }));
    }
    setUpdatedData((prevState) => ({
      updateData: {
        state: success ? true : false,
        message: success
          ? "Call note added successfully"
          : "Call note failed to be added",
      },
    }));
    setSelectedDisposition(null);
    setNote("");
    setselectedDispositionDesc("");
    setModalOpen(false);
  };

  return (
    <div className="user-data-container" style={{marginBottom: "1rem"}}>
      <div className="customer-widget-header">
        <p
          className="customer-widget-heading"
          style={{ width: "100%", padding: ".5rem .5rem" }}
        >
          Customer Service Log
        </p>
        {callNotes && callNotes.length >= 0 && (
          <div>
            {open ? (
              <button
                className="add-note-btn-open moveRight"
                onClick={() => handleOpen()}
              >
                <span style={{color: "#fff"}}>Add Note</span>
              </button>
            ) : (
              <ToolTip placement="left" titleHeading="Add Note">
                <AddIcon
                  className="add-note-btn-closed moveRight"
                  onClick={() => handleOpen()}
                />
              </ToolTip>
            )}
          </div>
        )}
        <ArrowDropDownIcon
          onClick={() => {
            setIsOpen(!open);
            setToggleDropdown(!toggleDropdown);
          }}
          className={`arrow-dropdown ${
            toggleDropdown ? "arrow-open" : "arrow-close"
          }`}
        />
      </div>
      <div>
        <div
          className={`${open ? "show-data-table-call" : "no-data-table-call"}`}
        >
          {loading && <Loading />}
          {callNotes && callNotes.length >= 0 && (
            <CallNotesTable callNotes={callNotes} open={open} />
          )}
          <EditModal open={modalIsOpen} handleClose={handleClose}>
            <>
              <div className="modal-header">
                <h2 style={{ padding: ".5rem", color: "#6acde6" }}>Add Note</h2>
                <CloseIcon
                  className="close-icons"
                  onClick={() => handleClose()}
                />
              </div>
              <FormControl
                variant="outlined"
                style={{
                  margin: 8,
                  width: "18rem",
                  left: "-7px",
                }}
                onChange={(e) => {
                  setselectedDispositionDesc(
                    e.nativeEvent.target[e.nativeEvent.target.selectedIndex]
                      .text
                  );
                  setSelectedDisposition(e.target.value);
                }}
              >
                <InputLabel htmlFor="outlined-age-native-simple" shrink>
                  {"Disposition"}
                </InputLabel>
                <Select native>
                  <option value={null}></option>
                  {dispData?.map(({ dispositionId, description }, idx) => {
                    return (
                      <option key={idx} value={dispositionId}>
                        {description}
                      </option>
                    );
                  })}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                style={{
                  margin: 8,
                  width: "7rem",
                  position: "absolute",
                  right: "9px",
                }}
                onChange={(e) => setSelectedOrderId(e.target.value)}
              >
                <InputLabel htmlFor="outlined-age-native-simple">
                  {"Order ID"}
                </InputLabel>
                <Select native>
                  <option value={null}></option>
                  {orders?.map(({ orderId }, idx) => {
                    return (
                      <option key={idx} value={orderId}>
                        {orderId}
                      </option>
                    );
                  })}
                </Select>
              </FormControl>
              <TextField
                id="outlined-multiline-static"
                label="Add note"
                multiline
                rows={11}
                variant="outlined"
                fullWidth={true}
                onChange={(e) => setNote(e.target.value)}
              />
              <button
                className="submit-note-btn moveRight"
                onClick={(e) => handleSubmitNote(e)}
              >
                <span style={{ color: "#fff" }}>Submit Note</span>
              </button>
            </>
          </EditModal>
        </div>
      </div>
    </div>
  );
};

export default CustomerCallNotesWidget;
